import logdna from '@logdna/browser'
import { computed, ref } from 'vue'
import { useTimeout } from './useTimeout'

export function useClipboard({
  copiedMessageDuration = 1500
} = {}) {
  const isSupported = computed(() => navigator && 'clipboard' in navigator)
  const text = ref('')
  const copied = ref(false)
  const timeout = useTimeout(() => {
    copied.value = false
  }, copiedMessageDuration, { immediate: false })

  async function copy(value = null) {
    if (!isSupported.value) {
      logdna.warn('Clipboard API is not supported')
      return
    }
    if (value === null) return

    try {
      await navigator.clipboard.writeText(value)
      text.value = value
      copied.value = true
      timeout.start()
    } catch (err) {
      logdna.warn('Clipboard API writeText method is not supported')
    }
  }

  return {
    isSupported,
    text,
    copied,
    copy
  }
}
